/**
 * File: utils.ts
 * Description: Utility functions for ContextBrowser component
 * Author: System
 * Created: 2025-10-06
 * Last Modified: 2025-10-06
 */

import { ExistingDocument } from './ContextBrowser';
import { SearchResultItem } from './SearchResultsFeedback';

/**
 * Convert ExistingDocument to SearchResultItem
 * Cleaner than inline mapping in JSX
 */
export const convertToSearchResultItem = (doc: ExistingDocument): SearchResultItem => ({
  id: doc.id,
  name: doc.name,
  source: doc.source,
  relevanceScore: doc.relevanceScore,
  description: doc.description,
  summary: doc.summary,
  category: doc.category,
  size: doc.size,
  lastModified: doc.lastModified,
  author: doc.author,
  tags: doc.tags,
  path: doc.path,
  wiki_path: doc.wiki_path,
  chunks: doc.chunks,
  searchMetadata: doc.searchMetadata,
});

/**
 * Convert array of ExistingDocument to SearchResultItem array
 */
export const convertDocumentsToSearchResults = (
  documents: ExistingDocument[],
): SearchResultItem[] => documents.map(convertToSearchResultItem);